<template><div><h1 id="artikelfilter" tabindex="-1"><a class="header-anchor" href="#artikelfilter"><span>Artikelfilter</span></a></h1>
<p>Filter, Artikel- — Eingrenzung der zu bearbeitenden Artikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der Artikelfilter dient der Eingrenzung der zu bearbeitenden Artikel. Je mehr Parameter angegeben werden, desto kleiner wird die Menge der Artikel, die dem Filter entsprechen. Ausnahmen sind die mit logischen Operatoren angegebenen Felder. Der Artikelfilter kann an verschiedenen Stellen im System aufgerufen und verwendet werden, so z.B. im Artikelstamm, den Partien oder auch in der Inventur zur Erfassung der Inventurpositionen.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<dl>
<dt>Artikelnummer:</dt>
<dd>
<p>Unterste gewünschte Artikelnummer</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Oberste gewünschte Artikelnummer</p>
</dd>
<dt>AUS / EIN:</dt>
<dd>
<p>Anzeige des aktuellen Status des Artikelfilters</p>
</dd>
<dt>Artikeltyp (N/A/F):</dt>
<dd>
<p>Artikeltyp</p>
</dd>
<dd>
<p>N = Normalartikel, nichtassemblierter Artikel</p>
</dd>
<dd>
<p>A = Assemblierter Artikel</p>
</dd>
<dd>
<p>F = Fiktiver Artikel</p>
</dd>
<dt>PM:</dt>
<dd>
<p>Productmanager</p>
</dd>
<dt>Artikelgruppe vorziehen:</dt>
<dd>
<p>Nur Artikel dieser Gruppe werden angezeigt</p>
</dd>
<dt>ausschliessen:</dt>
<dd>
<p>Artikel dieser Gruppe werden ausgeschlossen</p>
</dd>
<dt>Gesamtbestand:</dt>
<dd>
<p>Gesamtbestand aller Lager muss grösser gleich ... sein</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Gesamtbestand aller Lager muss kleiner gleich ... sein</p>
</dd>
<dt>im Lagerort:</dt>
<dd>
<p>Personen-ID des Lagers, an dem der Artikel eine Partie haben muss</p>
</dd>
<dt>Nur nicht auslieferbare Artikel?:</dt>
<dd>
<p>Standardvorschlag = nein</p>
</dd>
<dd>
<p>ja = Nur Artikel, die nicht auslieferbar sind, werden angezeigt</p>
</dd>
<dt>Nur mit unterschr Bestellpunkt?:</dt>
<dd>
<p>Standardvorschlag = nein</p>
</dd>
<dd>
<p>ja = Nur Artikel, bei denen der Bestellpunkt unterschritten wurde, werden angezeigt</p>
</dd>
<dt>letztes Inventurdatum:</dt>
<dd>
<p>Zeitraum, in dem die letzte Inventur stattgefunden hat</p>
</dd>
<dt>Nur mit Merkmal:</dt>
<dd>
<p>Artikelmerkmal muss vorhanden sein. Mit oder kann die Selektion auf zwei weitere Merkmale ausgedehnt werden</p>
</dd>
<dt>Kombination von Merkmalen:</dt>
<dd>
<p>Artikelmerkmal muss vorhanden sein. Mit und kann das Vorhandensein von 2 Merkmalen beim gleichen Artikel verlangt werden, mit den folgenden zwei und nicht das Vorhandensein von bis zu zwei weiteren Merkmalen bei den gesuchten Artikeln verneint werden</p>
</dd>
<dt>Artikel mit Lieferant vorziehen:</dt>
<dd>
<p>Personen-ID des Lieferanten, der Artikel muss von diesem Lieferanten stammen</p>
</dd>
<dt>ausschliessen:</dt>
<dd>
<p>Personen-ID des Lieferanten, der Artikel darf nicht von diesem Lieferanten stammen</p>
</dd>
<dt>Artikel mit Medium:</dt>
<dd>
<p>Artikel muss mit diesem Medium verkauft worden sein,</p>
</dd>
<dt>von Seite:</dt>
<dd>
<p>Grösser oder gleich Seitennummer im Medium</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Kleiner oder gleich Seitennummer im Medium</p>
</dd>
<dt>Zählungsergebnis:</dt>
<dd>
<p>Ergebnis des Zähllaufs. Muss nicht durchgeführt werden für die Bearbeitung der Adressen</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>ändern:</dt>
<dd>Ändern der Filterdefinition. Steigt der Benutzer erstmals ins Programm ein, sind die Parameter im Filter immer leer, solange die Session dauert, bleiben einmal geänderte Parameter erhalten und können geändert werden</dd>
<dt>einschalten:</dt>
<dd>Aktivieren des Filters. Solange der Filter aktiviert ist, werden in jedem Programm der Lagerverwaltung nur Artikel angezeigt, die dem Filter entsprechen</dd>
<dt>ausschalten:</dt>
<dd>Deaktivieren des Filters. Wird nur bei eingeschaltetem Filter angezeigt (sog. Switch)</dd>
<dt>zählen:</dt>
<dd>Führt einen Zähllauf durch, der die Anzahl Artikel (aufgrund der Filterkriterien) unten im Fenster im Feld &quot;Zählungsergebnis&quot; auflistet. Für die Bearbeitung von Artikeln muss NICHT zuerst zählen gewählt werden, es genügt das Einschalten des Artikelfilters</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


